<template>
    <div>
        <app-no-data-message v-if="!tableData.length" />
        <app-data-table
            :items="tableData"
            :fields="fields"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            @sort="onSort"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="require_files" slot-scope="{ item }">
                {{ item.require_files | yesno }}
            </template>
            <template slot="notes" slot-scope="{ item }">
                <h5><b-badge pill variant="primary">{{ item.notes.length }}</b-badge></h5>
            </template>
            <template slot="files" slot-scope="{ item }">
                <h5><b-badge pill variant="primary">{{ item.files.length }}</b-badge></h5>
            </template>
            <template slot="due_date" slot-scope="{ item }">
                {{ item.due_date | date }}
            </template>
            <template slot="actions" slot-scope="data">
                <b-button size="sm" :variant="!data.detailsShowing?'primary':'danger'" @click.stop="data.toggleDetails"><i v-if="!data.detailsShowing" class="fa fa-eye"></i><i v-else class="fa fa-eye-slash"></i></b-button>
                <b-button size="sm" variant="primary" @click="createNote(data.item)"><i class="fa fa-pencil-square-o"></i></b-button>
                <b-button size="sm" variant="primary" @click="uploadFiles(data.item)"><i class="fa fa-file"></i></b-button>
                <b-button size="sm" variant="success" @click="solveTask(data.item)"><i class="fa fa-check"></i></b-button>
            </template>
            <template slot="row-details" slot-scope="data">
                <app-task-details :the-data="data" /> 
            </template>
        </app-data-table>
    </div>    
</template>
<script>
    import fields from './fields';
    import Paginator from '../../../../UI/Controls/Paginator/Paginator.vue';
    import TaskDetails from '../../../../UI/Tasks/TaskDetails.vue';
    import NoDataMessage from '../../../../UI/Layout/NoDataMessage.vue';

    export default {
        components:{
            appPaginator: Paginator,
            appTaskDetails: TaskDetails,
            appNoDataMessage: NoDataMessage
        },
        data(){
            return {
                fields: fields
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            },
        },
        computed: {
            tableData(){
                if(!this.data || !this.data.data || !this.data.data.length) return [];

                return this.data.data.map(item => {
                    let today = moment();
                    let dueDate = moment(item.due_date);
                    // const _rowVariant = today.isSame(dueDate, 'day')?'ignore today':(today.isAfter(dueDate)?'ignore overdue':'');
                    // const _showDetails = false;
                    // return {...item, _rowVariant, _showDetails};
                    const classes = today.isSame(dueDate, 'day')?'today':(today.isAfter(dueDate)?'overdue':'');
                    const _rowDetails = true;
                    return {...item, classes, _rowDetails};
                });
            }
        },
        methods: {
            seeNotes(data){
                this.$emit('see-notes', data);
            },
            createNote(data){
                this.$emit('create-note', data);
            },
            uploadFiles(data){
                this.$emit('upload-files', data);
            },
            solveTask(data){
                this.$emit('solve-task', data);
            },
            toggleDetails(index) {
                const item = this.tableData[index];
                item.showDetails = !item.showDetails;
                this.tableData.splice(index, 1, item);
            },
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }
</script>
